import {Component, EventEmitter, Inject, Input, OnInit, Optional, Output, ViewContainerRef} from '@angular/core';
import {IOrderDetails} from "../../../interfaces";
import {basicTransition} from "../../../../libs/basicTransition";
import {MAT_DIALOG_DATA} from "@angular/material/dialog";
import {isNullOrUndefOrEmpty, toCurrency} from "../../../common";
import {StringJSV2Pipe} from "../../../pipes/stringjs-pipe";
import {Compbaser} from "../../../components/compbaser";
import {StoreSelectorsService} from "../../../services";
import * as _ from 'lodash';

@Component({
    selector: 'app-order-details',
    templateUrl: './order-details.component.html',
    styleUrls: ['./order-details.component.scss'],
    animations: [basicTransition]
})
export class OrderDetailsComponent extends Compbaser implements OnInit {

    private el: HTMLElement;
    private fields = ['company', 'first_name', 'last_name', 'address1', 'address2', 'state', 'county', 'zip_code', 'phone1'];
    m_order: IOrderDetails;
    m_orderId;
    m_paid;
    m_status;
    subsInvoice = false;
    subtotal = '0';
    tax = '0';
    discount = '0';
    shipping = '0';
    total = '0';
    products: Array<any>;
    showProgress = false;
    steps: Array<boolean> = [true, true, true, true];
    loading = false;
    stringJSPipe: StringJSV2Pipe;
    stringJSPipeArgs = {toCurrency: ['us']};
    printing = false;
    // logo;
    // appStatic: IAppStatic;

    @Input()
    set order(i_order: IOrderDetails) {
        if (!i_order) return;
        this.processOrder(i_order);
    }

    @Output() toggleMinimize = new EventEmitter<any>();

    constructor(private stringJS: StringJSV2Pipe,
                private storeSelector: StoreSelectorsService,
                private viewContainer: ViewContainerRef,
                @Optional() @Inject(MAT_DIALOG_DATA) data) {
        super();
        this.stringJSPipe = stringJS;
        this.el = this.viewContainer.element.nativeElement;
        if (data && data.orderDetails) {
            this.processOrder(data.orderDetails);
        }
        // this.cod(
        //     this.storeSelector.getAppSettings()
        //         .subscribe((i_appSettings: IAppStatic) => {
        //             this.appStatic = i_appSettings;
        //             // this.logo = `${this.appStatic.protocol}${this.appStatic.masterServer}/Resources/Resellers/1/Logo.png`;
        //         })
        // );
    }

    ngOnInit() {
    }

    processOrder(i_order) {
        this.m_order = i_order;
        this.m_paid = this.m_order?.order?.paid;
        this.m_status = this.m_order?.order?.status?.name;
        this.m_orderId = this.getOrderId();

        if (this.getStatus() === 'subscription') {
            this.subsInvoice = false;
            this.products = [{
                description: "mediaCLOUD subscription",
                product_count: 1,
                price: this.getSubscriptionPayment()
            }];

            // price: order._data._root.entries["3"]["1"].amount

            this.subtotal = this.getSubscriptionPayment();
            this.total = this.getSubscriptionPayment();
            this.shipping = '0';
            this.discount = '0';
            this.tax = '0';
        } else {
            this.subsInvoice = true;
            this.products = this.getOrderDetails();
        }
    }

    calcTotals() {
        // const {shippingTotal, subTotal, taxTotal, orderTotal} = calcTotals(this.dataSource.data, this.selectedShipBy);
        // this.shippingTotal = Number(this.dynawebsOrder.shipping_amount); // override shipping from db value and not computed value for dynawebs
        // this.subTotal = Number(subTotal);
        // if (this.dynawebsOrder.taxable) {
        //     this.taxTotal = Number(taxTotal);
        //     this.orderTotal = Number(orderTotal) + Number(this.shippingTotal);
        // } else {
        //     this.taxTotal = 0;
        //     this.orderTotal = Number(orderTotal) + Number(this.shippingTotal) - Number(taxTotal);
        // }
    }

    tableDesc(field): any {
        return field.description;
    }

    tableQty(field): any {
        return field.product_count;
    }

    // @Memoizee({})
    tablePrice(field): any {
        return () => {
            let price = !isNullOrUndefOrEmpty(field.product_price) ? field.product_price : field.price;
            price = parseFloat(price);
            return toCurrency(String(price), ['us']);
        };
    }

    // @Memoizee({})
    tableTotal(field): any {
        return () => {
            const price = !isNullOrUndefOrEmpty(field.product_price) ? field.product_price : field.price;
            const v: any = field.product_count * price;
            return toCurrency(String(parseFloat(v)), ['us']);
        };
    }


    // @Memoizee({})
    tableNotes(field): any {
        return () => {
            return field?.item_notes;
        };
    }

    printElem() {
        this.printing = true;
        this.showProgress = false;
        const mywindow = window.open('', this.getDate(), 'height=400,width=600');
        setTimeout(() => {
            const printContents = this.el.innerHTML;
            // var mywindow = window.open('', self.selectedOrder.getDate(), 'height=400,width=600');
            mywindow.document.write(`<html><head><title>${this.getOrderId()}</title>`);
            /*optional stylesheet*/ //
            mywindow.document.write('</head><body >');
            // mywindow.document.write('<link rel="stylesheet" href="http://localhost:9089/src/styles/style.css" type="text/css" />');
            mywindow.document.write(printContents);
            mywindow.document.write('</body></html>');
            mywindow.document.close(); // necessary for IE >= 10
            mywindow.focus(); // necessary for IE >= 10
            mywindow.print();
            mywindow.close();
        }, 1000);
        setTimeout(() => {
            this.printing = false;
        }, 10000);
        return true;
    }

    public getOrderId() {
        if (!this.m_order) return;
        if (this.m_order.subscription)
            return this.m_order.subscription.payment_id;
        if (!this.m_order?.order?.order_id) return;
        return this.m_order.order.order_id;
    }

    public getDate() {
        if (!this.m_order) return;
        const subscription = this.m_order.subscription;
        if (subscription)
            return new Date(subscription.payment_date).toLocaleDateString('us');
        if (this.m_order?.order?.order_date && this.m_order.orderDetails && this.m_order.orderDetails[0])
            return new Date(this.m_order.order.order_date).toLocaleDateString('us');
        if (this.m_order?.order?.order_date)
            return new Date(this.m_order.order.order_date).toLocaleDateString('us');
        return new Date().toLocaleDateString('us');
    }

    cleanField(v: string) {
        if (!v || _.isUndefined(v) || v === 'undefined' || v === 'UNDEFINED' || v === 'NULL' || v === 'null' || _.isNull(v) || v === '') return '';
        return v;
    }

    // @Memoizee({})
    private getCustomerInfo(type) {
        let str = '';
        const data = this.m_order[type];
        if (!data) return '';
        this.fields.forEach((field) => {
            if (data[field] && data[field].length > 0)
                str = str + this.cleanField(data[field]) + '\n';
        });
        return str;
    }

    public getBilling() {
        return this.getCustomerInfo('billing');
    }

    public getOrderDetails(): Array<any> {
        return this.m_order.orderDetails;
    }

    public getShipping() {
        return this.getCustomerInfo('shipping');
    }

    public getEmail() {
        return this.m_order.billing.email;
    }

    public getDiscount() {
        const order = this.m_order.order;
        if (_.isUndefined(order))
            return toCurrency(0);
        return toCurrency(order.discount_amount);
    }

    public getTax() {
        const order = this.m_order.order;
        if (_.isUndefined(order))
            return toCurrency(0);
        return toCurrency(order.tax_amount);
    }


    public getSubtotal() {
        const order = this.m_order.order;
        if (_.isUndefined(order))
            return toCurrency(99);
        return toCurrency(order.subtotal_amount);
    }

    public getTotal() {
        const order = this.m_order.order;
        if (_.isUndefined(order))
            return toCurrency(99);
        return toCurrency(order.amount);
    }

    public getShippingTotal() {
        const order = this.m_order.order;
        if (_.isUndefined(order))
            return toCurrency(0);
        return toCurrency(order.shipping_amount);
    }

    public getStatus() {
        const orderDetails = this.m_order.orderDetails;
        if (!orderDetails) return '';
        if (orderDetails.length === 0) return 'subscription';
        return 'order';
    }

    public getTracking() {
        const subscription = this.m_order.subscription;
        if (subscription)
            return '';
        return this.m_order.order.tracking;
    }

    public getSubscriptionPayment() {
        if (this.m_order.subscription && this.m_order.subscription.amount) {
            return this.m_order.subscription.amount;
        }
        if (this.m_order.order && this.m_order.order.amount) {
            return this.m_order.order.amount;
        }
    }
}
